import { format, formatDistanceToNow, parseISO } from 'date-fns';

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
  return format(d, 'MMM d, yyyy');
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '—';
  const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
  return format(d, 'MMM d, yyyy h:mm a');
}

export function formatRelative(dateStr) {
  if (!dateStr) return '—';
  const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
  return formatDistanceToNow(d, { addSuffix: true });
}

export function formatSalary(amount) {
  if (!amount && amount !== 0) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatPercent(value) {
  if (!value && value !== 0) return '—';
  return `${Math.round(value)}%`;
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map(w => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
